import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import img1 from "./cardImg/education.jpeg";
import img2 from "./cardImg/health1.jpeg";
import img3 from "./cardImg/finace1.jpeg";
import img4 from "./cardImg/ecom1.jpeg";
import img5 from "./cardImg/retail1.jpeg";
import img6 from "./cardImg/travel1.jpeg";
import img7 from "./cardImg/hospital1.jpeg";
import img8 from "./cardImg/logistics.jpeg";
import img9 from "./cardImg/realEstate.jpeg";
import img10 from "./cardImg/insurace.jpeg";
import img11 from "./cardImg/enterm.jpeg";
import img12 from "./cardImg/govt.jpeg";
import MobileCard from "./MobileCard";

const MobileCardComponent = () => {
  const cardData = [
    {
      card_img: img1,
      card_title: "Education🎓",
      //   card_title2: "(Founder)",
      card_description: "Use WhatsApp to simplify admissions, share study materials, send remindersand engage students in real time.",
      badge: "New",
    },
    {
      card_img: img2,
      card_title: "Healthcare 🏥",
      //   card_title2: "(Co-Founder)",
      card_description:
        "Streamline patient communication and appointment management through WhatsApp. A healthier way to connect.",
      badge: "New",
    },

    {
      card_img: img3,
      card_title: "Finance 💰",
      //   card_title2: "(Saas Developer)",
      card_description:
        "Automate timely reminders, paymentsand customer queries for seamless financial services.",
      badge: "New",
    },
    {
      card_img: img3,
      card_title: "E-commerce 🛍️",
      //   card_title2: "(Saas Developer)",
      card_description:
        "Enhance your customer experience with order tracking, notificationsand support on WhatsApp.",
      badge: "New",
    },
    {
      card_img: img5,
      card_title: "Retail 🛒",
      //   card_title2: "(Saas Developer)",
      card_description:
        "Boost sales by automating personalized offers and customer engagement via WhatsApp.",
      badge: "Premium",
    },
    {
      card_img: img6,
      card_title: "Traveling ✈️",
      //   card_title2: "(Saas Developer)",
      card_description:
        "Simplify bookings, itineraries, supportand real-time updates through WhatsApp for travelers.",
      badge: "Premium",
    },
    {
      card_img: img7,
      card_title: "Hospitality 🏨",
      //   card_title2: "(Graphics Designer)",
      card_description:
        "Offer a seamless guest experience with booking confirmations and customer support on WhatsApp.",
      badge: "Premium",
    },
    {
      card_img: img8,
      card_title: "Logistics 🚚",
      //   card_title2: "(Graphics Designer)",
      card_description:
        "Automate delivery notifications, order trackingand customer support for smooth logistics operations.",
      badge: "Premium",
    },
    {
      card_img: img9,
      card_title: "Real Estate 🏠",
      //   card_title2: "(Business Analyst)",
      card_description:
        "Engage leads, schedule site visitsand share property details easily via WhatsApp.",
      badge: "Upcoming",
    },
    {
      card_img: img10,
      card_title: "Insurance 🛡️",
      //   card_title2: "(Marketing)",
      card_description:
        "Assist customers with policy information, claimsand renewals through WhatsApp.",
      badge: "Upcoming",
    },
    {
      card_img: img11,
      card_title: "Media & Entertainment 🎥",
      //   card_title2: "(Marketing)",
      card_description:
        "Promote events, manage ticketsand engage audiences through WhatsApp.",
      badge: "Upcoming",
    },
    {
      card_img: img12,
      card_title: "Government Services 🏛️",
      //   card_title2: "(Marketing)",
      card_description:
        "Let people get gov services and info via WhatsApp chat easily.",
      badge: "Upcoming",
    },
  ];

  return (
    <Stack sx={{ display: { xs: "flex", sm: "none" } }}>
      <Grid container>
        {cardData.map((card, index) => (
          <Grid item xs={6} sm={6} key={index} sx={{ padding: 0 }}>
            <MobileCard
              card_img={card.card_img}
              card_title={card.card_title}
              card_title2={card.card_title2}
              card_description={card.card_description}
              index={index}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default MobileCardComponent;
